'use strict';

var React = require('react');
var _ = require('underscore');
var appTypes = require('../../types/appTypes');
var LabelParts = require('../common/LabelParts');
var IconParts = require('../common/IconParts');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');

/**
 * 图标按钮
 */
var IconLabel = React.createClass({
  render: function () {
    var props = _.extend({},this.props);
    props.x = props.y = 0;
    delete props.currentX;
    delete props.currentY;
    delete props.currentW;
    delete props.currentH;

    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var backgroundStyle = {
      width: '100%',
      height: '100%'
    };
    var iconStyle;
    var labelStyle;
    var size = styleHelper.getInt(this.props,propConst.SIZE);
    props.w = props.h = size;
    switch (this.props.iconDirection) {
    case appTypes.IconLabelDirection.TEXT_BOTTOM:
      props.x = (w - size)/2;
      labelStyle = {
        bottom : 0,
        width : '100%',
        textAlign : 'center'
      };
      break;
    case appTypes.IconLabelDirection.TEXT_LEFT:
      props.x = w - size;
      labelStyle = {
        height: '100%',
        lineHeight: h + 'px',
        left :0
      };

      break;
    case appTypes.IconLabelDirection.TEXT_RIGHT:
      labelStyle = {
        height: '100%',
        lineHeight: h + 'px',
        right : 0
      };
      break;
    }
    labelStyle.position = 'absolute';
    labelStyle.overflow = 'none';
    return (<div style={backgroundStyle}>
      <IconParts {...props}/>
      <LabelParts {...this.props} partStyle={labelStyle}/>
    </div>);
  }
});

module.exports = IconLabel;



// WEBPACK FOOTER //
// ./src/views/Components/IconLabel.jsx